import MasterUploader from "@/components/MasterUploader";
export default function StudentPrograms() {
  return (
    <MasterUploader
      kind="programs"
      title="Student Programs"
      subtitle="Master list of academic programs (e.g., B.Tech, MBA, LLB)."
      columns={[
        { key: "program_id", label: "Program ID", mono: true },
        { key: "program_name", label: "Program Name" },
        { key: "program_level", label: "Level" },
      ]}
      templateHint="program_id, program_name, program_level"
    />
  );
}
